import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { colors } from '../../../../theme';

export type StyleProps = {
  backgroundColor: string;
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.08)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      backgroundColor: ({ backgroundColor }: StyleProps): string =>
        backgroundColor,
      borderRadius: theme.spacing(1.25),
      border: '1px solid #DADADA',
      padding: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1),
      },
    },
    item: {
      margin: theme.spacing(0, 2),
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(0, 1),
      },
    },
    smallArt: {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    verticalLine: {
      borderLeft: '1px solid #DADADA',
      height: 40,
    },
    textContainer: {
      display: 'flex',
      flexFlow: 'column',
      textAlign: 'left',
    },
    text: {
      fontSize: theme.spacing(1.875),
      textAlign: 'start',
      fontWeight: 'bold',
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.spacing(1.5),
      },
    },
    lightBlue: {
      color: colors.bright_turquoise,
    },
    promoText: {
      fontWeight: 400,
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  }),
);
